import React, { useState } from "react"
import Button from "@material-ui/core/Button"
import CssBaseline from "@material-ui/core/CssBaseline"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import { makeStyles } from "@material-ui/core/styles"
import Container from "@material-ui/core/Container"
import { FormControl } from "@material-ui/core"
import InputAdornment from "@material-ui/core/InputAdornment"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import InputLabel from "@material-ui/core/InputLabel"
import LockIcon from "@material-ui/icons/Lock"
import Visibility from "@material-ui/icons/Visibility"
import VisibilityOff from "@material-ui/icons/VisibilityOff"
import FormHelperText from "@material-ui/core/FormHelperText"
import IconButton from "@material-ui/core/IconButton"
import { userNewPassword } from "@/apis"
import useFullPageLoader from "@/hooks/useFullPageLoader"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { userLogoutRequest } from "@/redux/actions/userAction"
import { urlPath } from "@/utils"

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    centerText: {
        textAlign: "center",
    },
    inputField: {
        marginTop: "10px",
        marginBottom: "10px",
    },
}))

export default function Register() {
    const [password, setPassword] = useState("")
    const [passwordConfirm, setPasswordConfirm] = useState("")
    const [showPassword, setShowPassword] = useState(false)
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false)
    const [snackbarOpen, setSnackbarOpen] = useState(false)
    const [requestSuccessStatus, setRequestSuccessStatus] = useState(false)
    const [responseMessage, setResponseMessage] = useState("")
    const [errorMsg, setErrorMsg] = useState({})
    const classes = useStyles()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev)
    }
    const handleClickShowPasswordConfirm = () => {
        setShowPasswordConfirm((prev) => !prev)
    }

    const handleMouseDownPassword = (event) => {
        event.preventDefault()
    }

    const handleSnackbarOpenStatus = (status) => {
        setSnackbarOpen(status)
    }

    const [loader, showLoader, hideLoader] = useFullPageLoader({
        content: "sending",
        requestSuccessStatus,
        responseMessage,
        snackbarOpen,
        handleSnackbarOpenStatus,
    })

    const handleSubmit = async (e) => {
        e.preventDefault()
        const urlString = window.location.href
        const url = new URL(urlString)
        const passwordToken = url.searchParams.get("token")

        if (!password)
            setErrorMsg((prevErrorMsg) => ({
                ...prevErrorMsg,
                password: "Please input password",
            }))
        if (!passwordConfirm)
            setErrorMsg((prevErrorMsg) => ({
                ...prevErrorMsg,
                passwordConfirm: "Please confirm your password",
            }))
        // TODO: password format
        if (password !== passwordConfirm) {
            setErrorMsg(() => ({
                password: "Please put the same password",
                passwordConfirm: "Please put the same password",
            }))
        } else if (errorMsg.password === "" && errorMsg.passwordConfirm === "") {
            showLoader()
            try {
                const result = await userNewPassword({ password, passwordToken })
                hideLoader()
                setRequestSuccessStatus(true)
                setResponseMessage(result.data.message)
                setSnackbarOpen(true)
                dispatch(userLogoutRequest)
                setTimeout(() => {
                    navigate(urlPath("login"))
                }, 1000)
            } catch (error) {
                setRequestSuccessStatus(false)
                setResponseMessage(error.data.message)
                setSnackbarOpen(true)
                hideLoader()
            }
        }
    }

    return (
        <>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <form className={classes.root} noValidate autoComplete="off">
                    <div className={classes.paper}>
                        <Typography component="h1" variant="h4">
                            Register
                        </Typography>
                        <Grid container spacing={1} alignItems="flex-end">
                            <Grid item xs={12}>
                                <FormControl fullWidth variant="outlined" error={!!errorMsg.password} className={classes.inputField}>
                                    <InputLabel htmlFor="outlined-adornment-password">Password *</InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        type={showPassword ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => {
                                            setPassword(e.target.value)
                                            setErrorMsg((prevErrorMsg) => ({
                                                ...prevErrorMsg,
                                                password: "",
                                            }))
                                        }}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <LockIcon />
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        labelWidth={90}
                                    />
                                    <FormHelperText id="component-error-text">{errorMsg.password}</FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl fullWidth variant="outlined" error={!!errorMsg.passwordConfirm} className={classes.inputField}>
                                    <InputLabel htmlFor="outlined-adornment-password">Confirm Password *</InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-password"
                                        type={showPasswordConfirm ? "text" : "password"}
                                        value={passwordConfirm}
                                        onChange={(e) => {
                                            setPasswordConfirm(e.target.value)
                                            setErrorMsg((prevErrorMsg) => ({
                                                ...prevErrorMsg,
                                                passwordConfirm: "",
                                            }))
                                        }}
                                        startAdornment={
                                            <InputAdornment position="start">
                                                <LockIcon />
                                            </InputAdornment>
                                        }
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPasswordConfirm}
                                                    onMouseDown={handleMouseDownPassword}
                                                    edge="end"
                                                >
                                                    {showPasswordConfirm ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                        labelWidth={160}
                                    />
                                    <FormHelperText id="component-error-text">{errorMsg.passwordConfirm}</FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={handleSubmit}
                        >
                            Confirm
                        </Button>
                    </div>
                </form>
            </Container>
            {loader}
        </>
    )
}
